<script setup lang="ts">
import { TriangleAlert } from 'lucide-vue-next'
import QrcodeVue from 'qrcode.vue'
import CopyLink from '@/components/CopyLink.vue'
import { QR_COLOR, qrLogoSettings } from '../lib/brandAppQr'

const QR_SIZE = 184

const { t } = useI18n()

const props = defineProps<{
  appUrl: string
  logo?: string
  hasUnsavedChanges?: boolean
}>()

const logoSettings = computed(() => qrLogoSettings(props.logo, QR_SIZE))
</script>

<template>
  <Popover>
    <PopoverTrigger as-child>
      <slot />
    </PopoverTrigger>
    <PopoverContent
      side="bottom"
      align="end"
      :side-offset="8"
      class="flex w-72 flex-col items-center gap-4 rounded-2xl p-5"
    >
      <div class="flex flex-col items-center gap-1 text-center">
        <p class="text-foreground text-sm font-semibold">{{ t('pages.loyaltySupports.webapp.editor.test.title') }}</p>
        <p class="text-foreground-secondary text-xs leading-relaxed">
          {{ t('pages.loyaltySupports.webapp.editor.test.description') }}
        </p>
      </div>
      <p v-if="!appUrl" class="text-destructive text-sm">
        {{ t('pages.loyaltySupports.webapp.editor.test.linkMissing') }}
      </p>
      <template v-else>
        <div class="relative">
          <QrcodeVue
            class="block"
            :value="appUrl"
            :size="QR_SIZE"
            :foreground="QR_COLOR"
            :image-settings="logoSettings"
            level="H"
            render-as="svg"
          />
          <img
            v-if="logo"
            :src="logo"
            alt=""
            class="absolute top-1/2 left-1/2 size-10 -translate-x-1/2 -translate-y-1/2 rounded-xl object-cover"
          />
        </div>
        <CopyLink :link="appUrl" class="w-full" />
      </template>
      <div
        v-if="hasUnsavedChanges"
        class="flex items-start gap-2 rounded-xl bg-amber-50 p-3 text-left text-xs leading-relaxed text-amber-800"
      >
        <TriangleAlert class="mt-0.5 size-3.5 shrink-0" />
        {{ t('pages.loyaltySupports.webapp.editor.test.unsaved') }}
      </div>
    </PopoverContent>
  </Popover>
</template>
